export default "__VITE_ASSET__1f622f76__"